import { HttpParams } from '@angular/common/http';
import { ObjectHelper } from './object.helper';

export class RequestHelper {
    public static createRequestOption = (req?: any): HttpParams => {
        let options: HttpParams = new HttpParams();
        if (req) {
            const flaternedObj = ObjectHelper.flattenObject(req);
            Object.keys(flaternedObj).forEach((key) => {
                if (flaternedObj[key]) {
                    options = options.set(key, flaternedObj[key]);
                }
            });
        }
        return options;
    };
}
